module.exports = __webpack_public_path__ + "static/media/triangle.85561782.svg";